'use client';

import { JSX, useEffect, useState } from 'react';

type Props = {
  redirectUrl: string;
  imageUrl: string;
};

export function CircleProgressBar(props: Props): JSX.Element {
  const [progress, setProgress] = useState(0);
  const redirectUri = props.redirectUrl;

  useEffect(() => {
    const duration = 3000;
    const interval = 50;
    const step = (interval / duration) * 100;
    const timer = setInterval(() => {
      setProgress((prev) => {
        const nextProgress = prev + step;
        if (nextProgress >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            window.location.href = redirectUri;
          }, 500);
          return 100;
        }
        return nextProgress;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [redirectUri]);

  const r = 100;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - progress) * circ) / 100;
  const strokeWidth = 6;

  return (
    <svg className="size-56" viewBox="0 0 200 200">
      <defs>
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="3"
            floodColor="#000"
            floodOpacity="0.1"
          />
        </filter>
      </defs>
      <circle
        className="stroke-current text-white"
        strokeWidth={strokeWidth}
        cx="100"
        cy="100"
        r="90"
        fill="#fbfcfd"
        filter="url(#shadow)"
      ></circle>
      <circle
        className="stroke-current text-fill/primary"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        cx="100"
        cy="100"
        r="90"
        fill="transparent"
        strokeDasharray={circ}
        strokeDashoffset={strokePct}
      ></circle>

      {props.imageUrl !== '' && (
        <image
          href={`${props.imageUrl}?width=120`}
          x="50"
          y="50"
          height="100"
          width="100"
        />
      )}
    </svg>
  );
}
